import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';

@Component({
    selector: 'app-alarm-color-indicator',
    templateUrl: './alarm-color-indicator.component.html',
    styleUrls: ['./alarm-color-indicator.component.css'],
    standalone: false,
})
export class AlarmColorIndicatorComponent implements OnChanges {
    @Input() title: string;
    @Input() status: any;
    @Input() color: string;
    @Input() alarmLevel: string;
    @Input() enabled: boolean;
    @Input() showAlpha: boolean = true;
    @Output() isVisibleChange = new EventEmitter<boolean>();

    @ViewChild('infoContainer') infoContainer: ElementRef;
    @ViewChild('indicator') indicator: ElementRef;

    isShowingInfo: boolean = false;
    rgb: string = '';
    alpha: number = 100;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.color && this.color) {
            this.parseRGBA(this.color);
        }
    }

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (
            !this.infoContainer?.nativeElement.contains(event.target) &&
            !this.indicator?.nativeElement.contains(event.target) &&
            this.isShowingInfo
        ) {
            this.isShowingInfo = false;
        }
    }

    showInfoMessage() {
        this.isShowingInfo = !this.isShowingInfo;
    }

    parseRGBA(rgbaString: string) {
        const match = rgbaString.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d\.]+)?\)/);

        if (!match) {
            return;
        }

        const r = parseInt(match[1], 10);
        const g = parseInt(match[2], 10);
        const b = parseInt(match[3], 10);
        const a = match[4] !== undefined ? parseFloat(match[4]) : 1;

        this.rgb = `${r}, ${g}, ${b}`;
        this.alpha = Math.round(a * 100);
    }
}
